module.exports = __webpack_public_path__ + "img/hibiscus.7945a3e1.png";